import { render, staticRenderFns } from "./TodoAvatar.vue?vue&type=template&id=0d7277dc&scoped=true&"
import script from "./TodoAvatar.vue?vue&type=script&lang=ts&"
export * from "./TodoAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./TodoAvatar.vue?vue&type=style&index=0&id=0d7277dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7277dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
